import { cn } from '@zealot/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

const emptyStateVariants = cva('flex flex-col items-center justify-center text-center', {
  variants: {
    variant: {
      default: 'rounded-lg border border-border bg-card px-6 py-12',
      inline: 'px-4 py-8',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type EmptyStateProps = React.ComponentProps<'div'> &
  VariantProps<typeof emptyStateVariants> & {
    icon?: React.ReactNode;
    title?: React.ReactNode;
    description?: React.ReactNode;
    action?: React.ReactNode;
  };

const EmptyState = ({
  className,
  variant = 'default',
  icon,
  title,
  description,
  action,
  ...props
}: EmptyStateProps) => {
  return (
    <div
      data-slot="empty-state"
      data-variant={variant}
      className={cn(emptyStateVariants({ variant, className }))}
      {...props}
    >
      {icon && (
        <div
          data-slot="empty-state-icon"
          className="mb-3 flex items-center justify-center text-muted-foreground [&_svg]:size-10"
        >
          {icon}
        </div>
      )}
      {title && (
        <h3 data-slot="empty-state-title" className="font-medium text-foreground text-sm">
          {title}
        </h3>
      )}
      {description && (
        <p data-slot="empty-state-description" className="mt-1 max-w-sm text-muted-foreground text-sm">
          {description}
        </p>
      )}
      {action && (
        <div data-slot="empty-state-action" className="mt-4">
          {action}
        </div>
      )}
    </div>
  );
};

export type { EmptyStateProps };
export { EmptyState, emptyStateVariants };
